import React, { useEffect, useState } from "react";
import { getComuniCoperti } from "../lib/istat";

/**
 * Select nativo (con datalist per ricerca rapida) per il campo Comune.
 * Popolato con l'elenco ISTAT dei comuni coperti dal Protocollo.
 * L'utente può digitare per filtrare — se il comune non è coperto, l'input mostra
 * un warning ma consente comunque l'inserimento (fallback libero).
 */
export const ComuneSelect = ({
  value,
  onChange,
  provincia = null,
  className = "editorial-input",
  required = false,
  disabled = false,
  testid,
  placeholder = "Inizia a digitare…",
}) => {
  const [comuni, setComuni] = useState([]);
  useEffect(() => { getComuniCoperti(provincia).then(setComuni); }, [provincia]);
  const listId = `istat-comuni-${provincia || "all"}`;
  const isCovered = !value || comuni.includes(value);
  return (
    <>
      <input
        list={listId}
        type="text"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        disabled={disabled}
        placeholder={placeholder}
        className={className}
        data-testid={testid}
        autoComplete="off"
      />
      <datalist id={listId}>
        {comuni.map((c) => <option key={c} value={c} />)}
      </datalist>
      {value && !isCovered && (
        <div className="text-xs text-[#B08D2E] mt-1">
          Territorio non ancora coperto dal Protocollo
        </div>
      )}
    </>
  );
};
